module.exports = __webpack_public_path__ + "img/cp-event-duration.dd47d63d.svg";